import React, { Component } from "react";

interface Props {
    onClickOuside: () => any;
}
 class OutsideClickDetector extends Component<Props> {
        private wrapperRef = React.createRef<HTMLDivElement>();
 
    constructor(props:Props) {
        super(props);

        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event:any) {
        if (this.wrapperRef && !this.wrapperRef?.current?.contains(event.target)) {
            this.props.onClickOuside()
        }
    }

    render() {
        return <div className='width-100-percents' ref={this.wrapperRef}>{this.props.children}</div>;
    }
}

export default OutsideClickDetector;
